import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { useLocation, useParams } from 'react-router-dom';
import Constants from "../../Utils/Constants";
import LoadingProgress from "../../Common/LoadingProgress";
import { getToken, getHeaders } from "../../Utils/Common";
import store from "../../Common/storage";
import Header from "../../assets/components/header";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Pagination from '@material-ui/lab/Pagination';
import "./../../index.css";
import toastMaker from "../../Common/toastmaker";



const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData, setServerData] = React.useState(store.get("history"));
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const location = useLocation();
  const [total, setTotal] = React.useState('');
  const [search, setSearch] = React.useState('');
  let interval = null;

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    load()
  }, [page]);

  const load = () => {
    axios.get(Constants.configurationsPvtApiPath + `?paging=yes&per_page=20&page=${page}&order_by=id&order=desc&${search}`, getHeaders())
                      .then(response => {
                        setPageCount(response.data.meta.last_page)
                        setTotal(response.data.meta.total)
                        setServerData(response.data.data)
                      }).catch(error => console.error(error))
  };

  return (
    <div className="panal-viewport middle-container">
          <Header name={"Select Company"} />
            <Paper className={`${classes.root} pb-2`}>
                <div className="">
                  <input 
                    style={{height: "45px", padding:"5px", margin: "0 5px"}}
                    className="input-box"
                    onChange={e => setSearch(e.target.value == '' ? '' : `name=${e.target.value}`)} 
                    placeholder="Search by name"
                  /> 
                  <button 
                    type="button"
                    className="c-button c-button_secondary"
                    onClick={e => load()} 
                  >Seach</button>
                </div>
              
              
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead >
                    <TableRow id="table-head_rw">
                      
                        <StyledTableCell className="table-hd">
                          Name
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Alias
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Host
                        </StyledTableCell>
    
                        {/* <StyledTableCell className="table-hd">
                          Api Key
                        </StyledTableCell> */}
    
                        <StyledTableCell className="table-hd">
                          Credits (Postpaid)
                        </StyledTableCell>
    
                        {/* <StyledTableCell className="table-hd">
                          Status
                        </StyledTableCell> */}
    
                        <StyledTableCell className="table-hd">
                          Action
                        </StyledTableCell>
    
                    </TableRow>
                  </TableHead>
                  <TableBody >
                    {
                      serverData?.map((c, i) => 
                          <StyledTableRow key={i} >
                            <StyledTableCell className="">
                              {c?.name}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.alias}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.host}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.last_balance} ({c?.allow_exceed ? 'Yes' : 'No'})
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              <button className="c-button" onClick={() => Constants.navigate(`${Constants.accountmanagement.replace(':id', c.id)}`)} style={{margin: '0 10px'}}> Manage </button>
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                    }
    
                    
                  </TableBody>
                </Table>
              </TableContainer>
              {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                                  <Pagination 
                                    count={pageCount} 
                                    page={page} 
                                    onChange={handleChange} 
                                    variant="outlined" 
                                    shape="rounded"
                                    />
                                </div>}
            </Paper>
        </div>
  );
}
